/**
 * 确保 runAfterInteractions 被调用到
 * https://github.com/facebook/react-native/issues/8624
 */
import { InteractionManager } from 'react-native';
const QInteractionManager = Object.assign(Object.assign({}, InteractionManager), { runAfterInteractions: (f) => {
        let called = false;
        const timeout = setTimeout(() => {
            called = true;
            f();
        }, 500);
        InteractionManager.runAfterInteractions(() => {
            if (called)
                return;
            clearTimeout(timeout);
            f();
        });
    } });
export default QInteractionManager;
